import {createContext, useContext, useMemo, useState} from 'react'

const VehicleContext = createContext()

export const VehicleProvider = ({ children }) => {
  const [vehicles, setVehiclesData] = useState([])
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const [selectedVehicle, setSelectedVehicle] = useState(null)
  const selectedVehicleName = useMemo(() => {
    if (!selectedVehicle) return

    const { make, model, phase, year } = selectedVehicle

    return [make, model, phase, year].filter(Boolean).join(' ')
  }, [selectedVehicle])
  const [hasBlockers, setHasBlockers] = useState(false)

  return (
    <VehicleContext.Provider
      value={{
        vehicles,
        setVehiclesData,
        loading,
        setLoading,
        pagination,
        setPagination,

        selectedVehicle,
        setSelectedVehicle,
        selectedVehicleName,

        hasBlockers,
        setHasBlockers,
      }}
    >
      {children}
    </VehicleContext.Provider>
  )
}

export const useVehicles = () => useContext(VehicleContext)
